import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, MapPin } from 'lucide-react';
import cx from 'classnames';

import PlaceGeoSuggest from '../../Home/PlaceGeoSuggest';
import messages from '../../../locale/messages';
import history from '../../../core/history';
import { setPersonalizedValues } from '../../../actions/personalized';
import { googleMapLoader } from '../../../helpers/googleMapLoader';

import s from './HeaderSearchBar.css';

class HeaderSearchBar extends React.Component {
  static propTypes = {
    isVisible: PropTypes.bool,
    personalized: PropTypes.object
  };

  static defaultProps = {
    isVisible: false,
    personalized: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      googleMapsApiLoaded: false
    };
  }

  async componentDidMount() {
    const autocompleteService = await googleMapLoader('places');
    this.setState({ googleMapsApiLoaded: true });
    this.autocompleteService = autocompleteService;
  }

  handleClick = () => {
    const { personalized } = this.props;
    let uri = '/s?';
    if (personalized?.chosen != null) {
      uri = uri + '&address=' + personalized?.location + '&chosen=' + personalized?.chosen;
    } else if (personalized?.location != null) {
      uri = uri + '&address=' + personalized?.location;
    }
    history.push(encodeURI(uri));
  }

  render() {
    const { isVisible } = this.props;
    const { formatMessage } = this.props.intl;
    const { googleMapsApiLoaded } = this.state;

    return (
      <AnimatePresence>
        {isVisible && (
          <motion.div
            className={s.searchBarContainer}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.95 }}
            transition={{ 
              duration: 0.3, 
              ease: [0.4, 0, 0.2, 1]
            }}
          >
            <div className={s.searchBarInner}>
              <div className={s.iconWrapper}>
                <MapPin size={18} className={s.locationIcon} />
              </div>
              <div className={s.inputWrapper}>
                {googleMapsApiLoaded ? (
                  <PlaceGeoSuggest
                    label={formatMessage(messages.homeWhere)}
                    className={s.searchInput}
                    containerClassName={s.geoSuggestContainer}
                  />
                ) : (
                  <input 
                    type="text" 
                    placeholder={formatMessage(messages.homeWhere)}
                    className={s.searchInput}
                    disabled
                  />
                )}
              </div>
              <motion.button
                type="button"
                className={s.searchButton}
                onClick={this.handleClick}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Search size={18} />
                <span className={s.searchText}>
                  <FormattedMessage {...messages.search} />
                </span>
              </motion.button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }
}

const mapState = (state) => ({
  personalized: state?.personalized
});

const mapDispatch = {
  setPersonalizedValues
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(HeaderSearchBar)));
